import { render } from "./Navbar.vue?vue&type=template&id=dfc8bf72&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=dfc8bf72&scoped=true&lang=css"

import exportComponent from "/home/cms/prod/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc8bf72"]])

export default __exports__